/* Probearing add-to-cart animation. Hooks theme's ajaxCart events; does not touch pb-ms-guard. */
(function(){
  if (window.__pbAtc) return; window.__pbAtc = 1;
  var BTN = '.js-product-add, form[action*="/cart/add"] [name="add"]';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)');
  var SVG = '<svg class="pb-atc-check" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var timers = new WeakMap(), lastBtn = null;

  function fx(btn){
    var el = btn.querySelector('.pb-atc-fx');
    if (!el) {
      btn.classList.add('pb-atc-on');
      el = document.createElement('span');
      el.className = 'pb-atc-fx'; el.setAttribute('aria-hidden', 'true');
      el.innerHTML = '<span class="pb-atc-spin"></span>' + SVG + '<span class="pb-atc-txt">Added</span>';
      btn.appendChild(el);
    }
    return el;
  }
  function live(msg){
    var r = document.getElementById('pb-atc-live');
    if (!r) { r = document.createElement('div'); r.id = 'pb-atc-live'; r.setAttribute('role', 'status'); r.setAttribute('aria-live', 'polite');
      r.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)'; document.body.appendChild(r); }
    r.textContent = ''; setTimeout(function(){ r.textContent = msg; }, 30);
  }
  function reset(btn){ clearTimeout(timers.get(btn)); btn.classList.remove('pb-atc-loading', 'pb-atc-done'); }
  function loading(btn){ reset(btn); fx(btn); btn.classList.add('pb-atc-loading'); lastBtn = btn;
    timers.set(btn, setTimeout(function(){ reset(btn); }, 8000)); }
  function done(btn){ if (!btn) return; clearTimeout(timers.get(btn)); fx(btn);
    btn.classList.remove('pb-atc-loading'); btn.classList.add('pb-atc-done'); live('Added to cart');
    timers.set(btn, setTimeout(function(){ reset(btn); }, reduce && reduce.matches ? 1200 : 1600)); }
  function bump(){
    if (reduce && reduce.matches) return;
    document.querySelectorAll('.cart-count-bubble, .js-cart-trigger').forEach(function(n){
      n.classList.remove('pb-atc-bump'); void n.offsetWidth; n.classList.add('pb-atc-bump');
      setTimeout(function(){ n.classList.remove('pb-atc-bump'); }, 800); });
  }

  // 1) loading state on click (capture, runs after guard's capture-phase block would have stopped it)
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest(BTN);
    if (!b || b.disabled || b.dataset.pbMs || b.getAttribute('aria-disabled') === 'true') return;
    var f = b.closest('form'); if (f && f.classList.contains('pb-ms-off')) return;
    if (b.type === 'submit' || b.closest('form')) loading(b);
  }, false);

  // 2) success / failure via the theme's ajaxCart events (jQuery)
  function wire(){
    if (!window.jQuery) return false;
    jQuery(document.body)
      .on('afterAddItem.ajaxCart', function(){ done(lastBtn); bump(); })
      .on('errorAddItem.ajaxCart', function(){ if (lastBtn) reset(lastBtn); });
    return true;
  }
  if (!wire()) document.addEventListener('DOMContentLoaded', wire);

  // 3) any other cart add (e.g. kit widgets): pulse when the header count rises
  var last = null;
  function watch(){
    var c = document.querySelector('.js-cart-count'); if (!c) return;
    last = parseInt(c.textContent, 10) || 0;
    new MutationObserver(function(){
      var n = parseInt(c.textContent, 10) || 0;
      if (last !== null && n > last && !document.querySelector('.pb-atc-bump')) bump();
      last = n;
    }).observe(c, {childList: true, characterData: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();

  // 4) open the cart drawer after any /cart/add (kit widgets, quick-add, etc.)
  (function(){
    if (window.__pbFetchWrapped || typeof window.fetch !== 'function') return;
    window.__pbFetchWrapped = true;
    var origFetch = window.fetch, timer = null;
    function visible(el){ return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }
    function refreshAndOpen(){
      clearTimeout(timer);
      timer = setTimeout(function(){
        try { window.ajaxCart && typeof ajaxCart.load == 'function' && ajaxCart.load(); } catch(e){}
        setTimeout(function(){
          var trig = Array.prototype.slice.call(document.querySelectorAll('.js-cart-trigger')).filter(visible)[0];
          trig && trig.click();
        }, 400);
      }, 300);
    }
    window.fetch = function(input, init){
      var url = typeof input == 'string' ? input : (input && input.url) || '',
          p = origFetch.apply(this, arguments);
      if (url.indexOf('/cart/add') !== -1) p.then(function(res){ res && res.ok && refreshAndOpen(); }).catch(function(){});
      return p;
    };
  })();
})();
